import type {CalculateParams} from '../types'
import {convertWidthToPx} from '../converters/width'
import type {GridContainerLayout} from '@wix/document-services-types'

export const calculateColumns = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.columns(compRef) !== undefined) {
        return
    }

    const columns = (layoutData?.containerLayout as GridContainerLayout)?.columns
    if (!columns) return

    const columnsInPx: number[] = []
    columns.forEach(column =>
        columnsInPx.push(
            convertWidthToPx[column.type]({
                ...calculateParams,
                ...column
            })
        )
    )
    set.columns(compRef, columnsInPx)
}
